export default __webpack_public_path__ + "static/media/Robot_08.29479cfe.png";